export default "__VITE_ASSET__BypYhQMl__"